import styled from 'styled-components';

export const StyledCountdownContainer = styled.div``;
